import type { CompanyType, PartnerCapability } from "@/schema/company"

export function canAccessPartnerFeature(
  companyType: CompanyType | undefined,
  capabilities: PartnerCapability[] | undefined,
  capability: PartnerCapability
) {
  if (!companyType) return false
  return companyType !== "integration_partner" || capabilities?.includes(capability) === true
}
